import { configureStore } from "@reduxjs/toolkit";
// import loginReducer from "./user/loginReducer";
import paginationFilterSlice from "./Pagination/filtersReducer";
// import leadsFilteredSlice from "./Filtered leads/filteredLeadReducer";
// import followupLeadsSlice from "./Filtered leads/followupLeadReducer";
// import enquiriesSlice from "./Filtered leads/enquiriesReducer";
// import buyerFilterSlice from "./Buyer/buyerFiltersReducer";
// import myOperatorSlice from "./Filtered leads/myOperatorRedux";
// import nhmApplicantsFilterSlice from "./Pagination/nhmApplicants";

export const store = configureStore({
  reducer: {
    // login: loginReducer,
    filters: paginationFilterSlice,
    // leadFilteredfilters: leadsFilteredSlice,
    // followupLeadsFilters: followupLeadsSlice,
    // myOperatorFilters: myOperatorSlice,
    // enquiriesFilters: enquiriesSlice,
    // buyerFilters: buyerFilterSlice,
    // nhmFilters: nhmApplicantsFilterSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});
